// Written in this round about way for babel-transform-imports
import Switch from 'react-router/es/Switch';

export default Switch;


//////////////////
// WEBPACK FOOTER
// ../~/react-router-dom/es/Switch.js
// module id = ../node_modules/react-router-dom/es/Switch.js
// module chunks = 0